// Import images
import GJGardnerLogo from "../../assets/images/dh-gj-gardner-logo.jpg";
import PerryHomesLogo from "../../assets/images/dh-perry-homes-logo.jpg";
import CoralHomesLogo from "../../assets/images/dh-coral-homes-logo.png";

// Import Perry Homes images
import PerryHomesFacade from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Facade.jpg";
import PerryHomes5 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (5).jpg";
import PerryHomes7 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (7).jpg";
import PerryHomes8 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (8).jpg";
import PerryHomes9 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (9).jpg";
import PerryHomes11 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (11).jpg";
import PerryHomes22 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (22).jpg";
import PerryHomes24 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (24).jpg";
import PerryHomes26 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (26).jpg";
import PerryHomes28 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (28).jpg";
import PerryHomes37 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (37).jpg";
import PerryHomes40 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (40).jpg";
import PerryHomes41 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (41).jpg";
import PerryHomes45 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (45).jpg";
import PerryHomes52 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (52).jpg";
import PerryHomes53 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (53).jpg";
import PerryHomes54 from "../../assets/images/builders/perryhomes/Aria 28/10088 Ballina Display_Aria28_Low Res (54).jpg";

// Import Perry Homes 2 images

import ThePalms00 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_Facade.jpg";
import ThePalms10 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (10).jpg";
import ThePalms21 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (21).jpg";
import ThePalms22 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (22).jpg";
import ThePalms35 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (35).jpg";
import ThePalms40 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (40).jpg";
import ThePalms45 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (45).jpg";
import ThePalms52 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (52).jpg";
import ThePalms55 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (55).jpg";
import ThePalms56 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (56).jpg";
import ThePalms75 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (75).jpg";
import ThePalms81 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (81).jpg";
import ThePalms86 from "../../assets/images/builders/perryhomes/The Palms/10089_Ballina Display_The Palms_LowRes (86).jpg";

// Builder data
const buildersData = {
    gjgardner: [
        {
            id: "gjgardner",
            logo: GJGardnerLogo,
            name: "GJ Gardner",
            description:
                "GJ Gardner, a multi award winning local business have built over 400 architecturally inspired homes. With a full design service available, they also offer a free site inspection to ensure their client's get the right advice to suit their family and budget.",
            homeName: "Parkview",
            homeDescription:
                "The Parkview has been specifically designed for wider lots, its expansive frontage creating a magnificent visage. Exclusive features make a luxury statement throughout and include timber flooring, custom cabinetry, study nook, walk in pantry, linen and wardrobes with the master suite boasting his and hers walk in robes with ensuite and double vanity.",
            homeImages: [
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/01/GJG_Exterior_936x644.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/01/GJG_Interior_1_936x644.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/01/GJG_Interior_2_936x644.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/01/GJG_Interior_3_936x644.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/01/GJG_Interior_4_936x644.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/01/GJG_Interior_5_936x644.jpg",
            ],
            beds: 4,
            baths: 3,
            cars: 2.5,
            contactInfo:
                "Book an appointment to view the GJ Gardner display home\nKane Munro 0411 740 878 or Robyn Frohlich 0439 390 309",
            openHours: "Open Friday to Tuesday, 10am to 4pm",
            buttonText: "Find out more about GJ Gardner",
            buttonLink: "https://www.gjgardner.com.au",
        },
    ],
    perryhomes: [
        {
            id: "perryhomes",
            logo: PerryHomesLogo,
            name: "Perry Homes",
            description:
                "A flexible home designed for the changing lives of a growing family. To the rear of the home is the master bedroom complete with walk-in robe and ensuite along with two further bedrooms and the main bathroom. To the front of the property is the fourth bedroom which benefits from its own bathroom. This combined with the rumpus room can easily be divided from the rest of the house making it perfect for dual living should a family member need to reside with you or you have a teenager craving their own space!",
            homeName: "Aria 28",
            homeDescription:
                "The expansive open plan living area boasts a gourmet kitchen complete with butler's pantry and overlooks the outdoor entertaining area.",
            homeImages: [
                PerryHomesFacade,
                PerryHomes5,
                PerryHomes7,
                PerryHomes8,
                PerryHomes9,
                PerryHomes11,
                PerryHomes22,
                PerryHomes24,
                PerryHomes26,
                PerryHomes28,
                PerryHomes37,
                PerryHomes40,
                PerryHomes41,
                PerryHomes45,
                PerryHomes52,
                PerryHomes53,
                PerryHomes54,
            ],
            beds: 4,
            baths: 3,
            cars: 2,
            livingRooms: 2,
            contactInfo:
                "While we accept walk-in traffic, we encourage you to book an appointment\nChris Littlewood 0411 611 842",
            openHours: "Open Saturday to Wednesday, 10am - 4pm",
            buttonText: "Find out more about Perry Homes",
            buttonLink: "https://www.perryhomes.com.au",
        },
        {
            id: "perryhomes2",
            logo: PerryHomesLogo,
            name: "Perry Homes",
            description:
                "The stunning Palms design is the perfect family two storey home, boasting four bedrooms and three living spaces. As you walk into the home there is a guest suite located to the front of the property offering separation from the rest of the home. To the rear of the home is a dedicated media room and the open plan living area. The kitchen is an entertainer’s dream with ample bench space and a large walk-in pantry.",
            homeName: "The Palms 34",
            homeDescription:
                "Upstairs, the expansive mastersuite with a large walk-in robe and ensuite provides the perfect retreat. There are two further bedrooms – both with walk-in robes and the option to have ensuites or a shared bathroom.",
            homeImages: [
                ThePalms00,
                ThePalms10,
                ThePalms21,
                ThePalms22,
                ThePalms35,
                ThePalms40,
                ThePalms45,
                ThePalms52,
                ThePalms55,
                ThePalms56,
                ThePalms75,
                ThePalms81,
                ThePalms86,
            ],
            beds: 4,
            baths: 3,
            cars: 2,
            livingRooms: 3,
            contactInfo:
                "While we accept walk-in traffic, we encourage you to book an appointment\nChris Littlewood 0411 611 842",
            openHours: "Open Saturday to Wednesday, 10am - 4pm",
            buttonText: "Find out more about Perry Homes",
            buttonLink: "https://www.perryhomes.com.au",
        },
    ],
    coralhomes: [
        {
            id: "coralhomes",
            logo: CoralHomesLogo,
            name: "Coral Homes",
            description:
                "Coral Homes offer a range of new innovative home designs at an affordable price. The leading home builder has over 30 years' experience and is best known for their competitive prices and value for money. Whether you're buying your first home, looking for more room to raise a family or downsizing to something more manageable, Coral Homes will have a home design to suit your land and lifestyle.",
            homeName: "Noosaville 25",
            homeDescription:
                "You'll be transported to a coastal oasis from the moment you are welcomed to the grand entrance of the Noosaville 25. This four-bedroom home boasts two comfortable living spaces and offers exceptional value whilst the indoor/outdoor integration is perfect for entertaining. A dreamy coastal home - one you won't want to miss!",
            homeImages: [
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Facade.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Kitchen-2.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Kitchen_Living.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Kitchen.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Living_Dining_Kitchen.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Master-Bedroom.jpg",
                "https://v1.banyanhill.com.au/full/wp-content/uploads/2020/04/Noosaville-25-Ballina-Ensuite.jpg",
            ],
            beds: 4,
            baths: 2,
            cars: 2,
            contactInfo:
                "The Coral Homes display home consultant may be contacted at:\nPhone 0409 516 970",
            openHours: "Open 7 Days, 10am to 5pm. No appointment necessary.",
            buttonText: "Find out more about Coral Homes",
            buttonLink: "https://www.coralhomes.com.au",
            virtualTourButton: {
                text: "Click here for a virtual tour",
                link: "https://my.matterport.com/show/?m=c7zgfazwCm1&kb=0&play=1",
            },
        },
    ],
};

export default buildersData;
